import { Link, Navigate, Outlet, useNavigate } from "react-router-dom";

import Layout from "./Layout";
import { useContext, useEffect } from "react";
import { LayoutProvider } from "../context/layoutContext";
import { UserContext } from "../context/userContext";

export const ProtectedRoute = ({ children, allowedRoles, userRole }: any) => {


  const navigate = useNavigate();

  const { user } = useContext(UserContext);

  if (!user) {
    // If user is not authenticated, redirect to login
    alert(user)
    return <Navigate to="/login" />;
  }

  if (!allowedRoles.includes(userRole)) {
    // If user does not have the required role, redirect to unauthorized page
    return <Navigate to="/unauthorized" />;
  }
  


  return (
    
      <Layout>
        <Outlet />
      </Layout>
  )
};
